import { Link } from 'react-router-dom';
import { categoryEntries } from '@/mocks/home';

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-sm font-bold text-foreground-400 uppercase tracking-wider">
              结构化入口
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2 italic">
              热点分类矩阵
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            按分类快速找到你感兴趣的吃瓜内容，热门大瓜、黑料曝光、吃瓜大赛一网打尽
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {categoryEntries.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer"
            >
              <div className="bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                </div>

                {/* Content */}
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold whitespace-nowrap">
                      {cat.name}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {cat.count}条内容
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    <span>立即查看</span>
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}